import {
  createMultipartUpload,
  type CreateMultipartUploadOptions,
  type MultipartUploadHandle,
} from "@/client/media-upload";

/** Its own module so the drain loop's tests can replace the handle. */
export function createUploadHandle(
  file: File,
  opts: CreateMultipartUploadOptions
): MultipartUploadHandle {
  return createMultipartUpload(file, opts);
}
